import { boolean, integer, pgTable, text, timestamp } from "drizzle-orm/pg-core";

export const user = pgTable("user", {
					id: text('id').primaryKey(),
					name: text('name').notNull(),
 email: text('email').notNull().unique(),
 emailVerified: boolean('email_verified').notNull(),
 image: text('image'),
 createdAt: timestamp('created_at').notNull(),
 updatedAt: timestamp('updated_at').notNull(),
 role: text('role'),
 banned: boolean('banned'),
 banReason: text('ban_reason'),
 banExpires: timestamp('ban_expires'),
 username: text('username').unique(),
 displayUsername: text('display_username')
				});

export const session = pgTable("session", {
					id: text('id').primaryKey(),
					expiresAt: timestamp('expires_at').notNull(),
 token: text('token').notNull().unique(),
 createdAt: timestamp('created_at').notNull(),
 updatedAt: timestamp('updated_at').notNull(),
 ipAddress: text('ip_address'),
 userAgent: text('user_agent'),
 userId: text('user_id').notNull().references(()=> user.id, { onDelete: 'cascade' }),
 impersonatedBy: text('impersonated_by')
				});

export const account = pgTable("account", {
					id: text('id').primaryKey(),
					accountId: text('account_id').notNull(),
 providerId: text('provider_id').notNull(),
 userId: text('user_id').notNull().references(()=> user.id, { onDelete: 'cascade' }),
 accessToken: text('access_token'),
 refreshToken: text('refresh_token'),
 idToken: text('id_token'),
 accessTokenExpiresAt: timestamp('access_token_expires_at'),
 refreshTokenExpiresAt: timestamp('refresh_token_expires_at'),
 scope: text('scope'),
 password: text('password'),
 createdAt: timestamp('created_at').notNull(),
 updatedAt: timestamp('updated_at').notNull()
				});

export const verification = pgTable("verification", {
					id: text('id').primaryKey(),
					identifier: text('identifier').notNull(),
 value: text('value').notNull(),
 expiresAt: timestamp('expires_at').notNull(),
 createdAt: timestamp('created_at'),
 updatedAt: timestamp('updated_at')
				});

export const passkey = pgTable("passkey", {
					id: text('id').primaryKey(),
					name: text('name'),
 publicKey: text('public_key').notNull(),
 userId: text('user_id').notNull().references(()=> user.id, { onDelete: 'cascade' }),
 credentialID: text('credential_i_d').notNull(),
 counter: integer('counter').notNull(),
 deviceType: text('device_type').notNull(),
 backedUp: boolean('backed_up').notNull(),
 transports: text('transports'),
 createdAt: timestamp('created_at')
				});

export const apikey = pgTable("apikey", {
					id: text('id').primaryKey(),
					name: text('name'),
 start: text('start'),
 prefix: text('prefix'),
 key: text('key').notNull(),
 userId: text('user_id').notNull().references(()=> user.id, { onDelete: 'cascade' }),
 refillInterval: integer('refill_interval'),
 refillAmount: integer('refill_amount'),
 lastRefillAt: timestamp('last_refill_at'),
 enabled: boolean('enabled'),
 rateLimitEnabled: boolean('rate_limit_enabled'),
 rateLimitTimeWindow: integer('rate_limit_time_window'),
 rateLimitMax: integer('rate_limit_max'),
 requestCount: integer('request_count'),
 remaining: integer('remaining'),
 lastRequest: timestamp('last_request'),
 expiresAt: timestamp('expires_at'),
 createdAt: timestamp('created_at').notNull(),
 updatedAt: timestamp('updated_at').notNull(),
 permissions: text('permissions'),
 metadata: text('metadata')
				});
